import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=aaa94ff6&"
import script from "./TeamList.vue?vue&type=script&lang=ts&"
export * from "./TeamList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports